import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-exp-sequence",
  "use": "icon-exp-sequence-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" fill=\"none\" id=\"icon-exp-sequence\">\n  <path d=\"M14 2.5 2 7.5l5 2 2 5 5-12Z\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n  <path d=\"M14 2.5 7 9.5\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol